/**
 * HTML-Parsen ohne Nebenwirkungen. Ein über createHTMLDocument erzeugtes Dokument hat keinen
 * Browsing-Context, deshalb lädt der Browser darin keine Bilder — nötig für cid:-Quellen, die er
 * sonst erfolglos abzurufen versucht (ERR_UNKNOWN_URL_SCHEME bzw. CSP-Verstoß in der Taskpane).
 */

let inertDocument: Document | null = null;

function getInertDocument(): Document {
  if (!inertDocument) {
    inertDocument =
      typeof document.implementation?.createHTMLDocument === "function"
        ? document.implementation.createHTMLDocument("sunnysign")
        : document;
  }
  return inertDocument;
}

/** Container mit geparstem HTML; Kindknoten über `container.ownerDocument` erzeugen. */
export function parseHtmlInert(html: string): HTMLDivElement {
  const div = getInertDocument().createElement("div");
  div.innerHTML = html;
  return div;
}
